
export default {
  signInNotRegistered: "Not registered yet?",
  signInRegister: "Sign up",
  message: 'English',
  LoginPersonalAcc: "Login to your account",
  getCode: "Get code",

  logout: 'Logout',
  Enter: "Enter",
  verificationCode: "Verification Code",
  reports: 'Reports',
  sales_summary: 'Sales summary',
  abc_analysis: 'ABC-analysis',
  sales_by_item: 'Sales by item',
  sales_by_category: 'Sales by category',
  sales_by_employee: 'Sales by employee',
  sales_by_payment: 'Sales by payment',
  receipts: 'Receipts',
  debts: 'Debts',
  discounts: 'Discounts',
  taxes: 'Taxes',
  shifts: 'Shifts',

  items: 'Items',
  item_list: 'Item list',
  categories: 'Categories',
  modifiers: 'Modifiers',

  inventory_management: 'Inventory management',
  purchase_orders: 'Purchase orders',
  online_kassa: 'Sale',
  transfer_orders: 'Transfer orders',
  stock_adjusment: 'Stock adjustment',
  inventory_counts: 'Inventory counts',
  productions: 'Productions',
  suppliers: 'Suppliers',
  inventory_history: 'Inventory history',
  inventory_valuation: 'Inventory valuation',
  supplier_valuation: "Supplier valuation",
  has_variants: "Has variants",

  employees: 'Employees',
  employee_list: 'Employee list',
  access_rights: 'Access rights',
  timecards: 'Timecards',
  total_hours_worked: 'Total hours worked',

  customers: 'Customers',

  settings: 'Settings',
  general: 'General',
  payment_types: 'Payment types',
  loyalty: 'Loyalty',
  open_tickets: 'Open tickets',
  kitchen_printers: 'Kitchen printers',
  stores: 'Stores',
  pos_devices: 'POS Devices',

  all_day: 'All day',
  custom: 'Custom',
  start: 'Start',
  end: 'End',
  all_stores: 'All stores',
  all_employes: "All employee",
  all_employees: 'All employees',
  all_reasons: 'All reasons',
  gross_sales: 'Gross sales',
  refunds: 'Refunds',
  net_sales: 'Net sales',
  gross_profit: 'Gross profit',
  date: 'Date',
  cost_of_goods: 'Cost of goods',

  item_name: 'Item name',
  items_sold: 'Items sold',
  gross_profit_analysis: 'Gross profit analysis',
  net_sales_analysis: 'Net sales analysis',
  gross_sales_analysis: 'Gross sales analysis',

  item: 'Item',
  sku: 'SKU',
  category: 'Category',
  items_refunded: 'Items refunded',

  average_sale: 'Average sale',

  payment_type: 'Payment type',
  payment_transactions: 'Payment transactions',
  payment_amount: 'Payment amount',
  refund_transactions: 'Refund transactions',
  refund_amount: 'Refund amount',
  net_amount: 'Net amount',

  all: 'All',
  sales: 'Sales',
  sold: 'Sold',
  receipt_no: 'Receipt no.',
  store: 'Store',
  employee: 'Employee',
  customer: 'Customer',
  type: 'Type',
  total: 'Total',
  cashier: 'Cashier',
  pos: 'POS',

  donator: 'Donator',
  accepted_time: 'Accepted time',
  receiver: 'Receiver',
  receive: 'Receive',
  charged: 'Charged',

  name: 'Name',
  discount_applied: 'Discount applied',
  amount_applied: 'Amount applied',

  taxable_sales: 'Taxable sales',
  non_taxable_sales: 'Non-taxable sales',
  total_net_sales: 'Total net sales',
  tax_name: 'Tax name',
  tax_amount: 'Tax amount',

  opening_time: 'Opening time',
  closing_time: 'Closing time',
  exp_cash_amount: 'Expected cash amount',
  act_cash_amount: 'Actual cash amount',
  difference: 'Difference',
  shift_report: 'SHIFT REPORT',
  shift_opened: 'Shift opened',
  shift_closed: 'Shift closed',
  cash_drawer: 'Cash drawer',
  starting_cash: 'Starting cash',
  cash_payments: 'Cash payments',
  cash_refunds: 'Cash refunds',
  paid_in: 'Paid in',
  paid_out: 'Paid out',

  add_item: 'Add item',
  import: 'Import',
  export: 'Export',
  upload: 'Upload',
  print_labels: 'Print labels',
  stock_alert: 'Stock alert',
  create_item: 'Create item',
  update_item: 'Update item',
  sold_by: 'Sold by',
  each: 'Each',
  weight: 'Weight',
  price: 'Price',
  cost: 'Cost',
  barcode: 'Barcode',
  inventory: 'Inventory',
  composite_item: 'Composite item',
  online_store: 'Online store',
  track_stock: 'Track Stock',
  use_production: 'Use production',
  quantity: 'Quantity',
  you_have_not_selected_items_yet: 'You have not selected items yet',
  available: 'Available',
  primary_supplier: 'Primary supplier',
  default_purchase_cost: 'Default purchase cost',
  in_stock: 'In stock',
  all_items: 'All items',
  low_stock: 'Low stock',
  equal_to_zero: 'Equal to zero',
  out_of_stock: 'Not in stock',
  positive: 'Positive',
  optimal_stock: 'Optimal stock',
  representation: 'Representation',
  color_and_shape: 'Color and shape',
  square: 'Square',
  circle: 'Circle',
  octagonal: 'Octagonal',
  hexagon: 'Hexagon',
  cancel: 'Cancel',
  create: 'Create',
  label_type: 'Label type',
  barcode_source_field: 'Barcode source field',
  print_name: 'Print name',
  print_price: 'Print price',
  add_by_category: 'Add by category',
  add_by_supplier: 'Add by supplier',
  please_add_at_least_one_item: 'Please add at least one item',
  print: 'Print',
  create_labels: 'Create labels',

  add_category: 'Add category',
  delete: 'Delete',
  create_category: 'Create category',
  category_name: 'Category name',
  update: 'Update',

  add_modifier: 'Add modifier',
  modifier: 'Modifier',
  modifier_name: 'Modifier name',
  option_name: 'Option name',
  add_option: 'Add option',
  save: 'Save',

  add_discount: 'Add discount',
  value: 'Value',
  percentage: 'Percentage',
  amount: 'Amount',

  supplier_contract: 'Contract №',
  tin: 'Tin',
  add_purchase: 'Add purchase',
  status: 'Status',
  supplier: 'Supplier',
  purchase_order: 'Purchase order',
  received: 'Received',
  exp_on: 'Expected on',
  create_purchase: 'Create purchase',
  purchase_order_date: 'Purchase order date',
  expected_on: 'Expected on',
  note: 'Note',
  incoming: 'Incoming',
  purchase_cost: 'Purchase cost',
  add_additional_cost: 'Add additional cost',
  additional_cost: 'Additional cost',
  ordered_by: 'Ordered by',
  destination_store: 'Destination store',
  closed: 'Closed',
  pending: 'Pending',
  returned_order: 'Returned order',
  partially: 'Partially',
  notes: 'Notes',

  add_transfer: 'Add transfer',
  add_online_stores: 'Add online store',
  create_online_store: 'Create online store',

  transfer_order: 'Transfer order',
  source_store: 'Source store',
  create_transfer: 'Create transfer',
  date_of_tranfer_order: 'Date of tranfer order',
  source_stock: 'Source stock',
  destination_stock: 'Destination stock',
  in_transit: 'In transit',
  transferred: 'Transferred',
  edit: 'edit',
  more: 'more',
  canceled: 'canceled',

  add_stock_adjustment: 'Add stock adjustment',
  reason: 'Reason',
  receive_items: 'Receive items',
  returned_back: 'Returned back',
  returned: 'Returned',
  recounted: 'Recounted',
  inventory_count: 'Inventory count',
  recount: 'Inventory count',
  loss: 'Loss',
  lost: 'Lost',
  'item edit': 'Item Edited',
  damage: 'Damage',
  damaged: 'Damaged',
  create_stock_adjustment: 'Create stock adjustment',
  add_stock: 'Add stock',
  stock_after: 'Stock after',
  all_stock_adjustment: 'All stock adjustment',
  adjusted_by: 'Adjusted by',
  expected_stock: 'Expected stock',
  counted_stock: 'Counted stock',
  remove_stock: 'Remove stock',

  add_inventory_count: 'Add inventory count',
  in_progress: 'In progress',
  completed: 'Completed',
  date_created: 'Date created',
  date_completed: 'Date completed',
  create_inventory_count: 'Create inventory count',
  partial: 'Partial',
  full: 'Full',
  created_by: 'Created by',
  counted: 'Counted',
  cost_difference: 'Cost difference',
  count_stock: 'Count stock',

  add_production: 'Add production',
  production: 'Production',
  disassembly: 'Disassembly',
  create_production: 'Create production',

  add_supplier: 'Add supplier',
  contact: 'Contact',
  phone_number: 'Phone number',
  email: 'Email',
  create_supplier: 'Create supplier',
  supplier_name: 'Supplier name',
  website: 'Website',
  address: 'Address',
  address_1: 'Address 1',
  address_2: 'Address 2',
  city: 'City',
  postal_zip_code: 'Postal/zip code',
  country: 'Country',
  region_state_province: 'Region/State/Province',

  adjustment: 'Adjustment',

  total_inventory_value: 'Total inventory value',
  total_retail_value: 'Total retail value',
  potential_profit: 'Potential profit',
  margin: 'Margin',
  inventory_value: 'Inventory value',
  retail_value: 'Retail value',

  add_employee: 'Add employee',
  role: 'Role',
  password: 'Password',

  add_role: 'Add role',
  access: 'Access',
  employees_can_log_in_to_the_app_using_personal_PIN_code: 'Employees can log in to the app using personal PIN code',
  close_ticket: 'Close ticket',
  print_pre_check: 'Print pre check',
  refund: 'Refund',
  show_all_receipts: 'Show all receipts',
  pay_debt: 'Pay debt',
  show_shift_history: 'Show shift history',
  apply_discount: 'Apply discount',
  change_settings: 'Change settings',
  show_stock: 'Show stock',
  edit_items: 'Edit items',
  edit_ticket: 'Edit ticket',
  split_check: 'Split check',
  change_waiter: 'Change waiter',
  change_ticket: 'Change ticket',
  delete_ticket: 'Delete ticket',
  show_all_tickets: 'Show all tickets',
  back_office: 'Back office',
  employees_can_log_in_to_the_back_office_using_their_email_and_password: 'Employees can log in to the back office using their email and password',
  edit_profile: 'Edit profile',
  set_the_taxes: 'Set the taxes',
  manage_pos_devices: 'Manage pos devices',
  can_delete_item: 'Can delete item',

  add_timecard: 'Add timecard',
  clock_in: 'Clock in time',
  clock_out: 'Clock out time',
  total_hours: 'Worked hours',
  clock_in_date: 'Clock in date',
  clock_out_date: 'Clock out date',
  clock_in_time: 'Clock in time',
  clock_out_time: 'Clock out time',

  add_customer: 'Add customer',
  contacts: 'Contacts',
  first_visit: 'First visit',
  last_visit: 'Last visit',
  total_visits: 'Total visits',
  total_spent: 'Total spent',
  points_balance: 'Points balance',
  first_name: 'First name',
  last_name: 'Last name',

  general_settings: 'General settings',
  bussiness_name: 'Bussiness name',
  UI_language: 'UI language',
  features: 'Features',
  track_cash_that_goes_in_and_out_of_your_drawer: 'Track cash that goes in and out of your drawer.',
  time_clock: 'Time clock',
  track_employees_clock_in_out_time_and_calculate_their_total_work_hours: `Track employees’ clock in/out time and calculate their total work hours.`,
  allow_to_save_and_edit_orders_before_completing_a_payment: 'Allow to save and edit orders before completing a payment.',
  show_my_debts: 'Show my debts',
  open_receipts: 'Open receipts',
  save_receipt_as_unpaid: 'Save receipt as unpaid',
  orders: 'Orders',
  show_customer_order_section_and_and_get_orders: 'Show customer order section and and get orders',
  chat: 'Chat',
  show_support_chat_section: 'Show support chat section',
  karaoke: 'Karaoke',
  can_sell_karaoke_type_item: 'Can sell karaoke type item',
  scale: 'Scale',
  connect_to_scale_for_markets: 'Connect to scale for markets',
  section: 'Section',
  enable_the_bar_printers: 'Enable the bar printers',
  inventery_menegment: 'Inventery menegment',
  local_server: 'Local Server',
  share_tickets_in_a_local_area_call_us_before_turn_it_on: 'Share tickets in a local area, call us before turn it on!',
  cash: 'Cash',
  card: 'Card',
  gift: 'Gift',
  debt: 'Debt',
  qr_code: 'QR Code',
  nfc: 'NFC',
  online_payment: 'Online payment',
  transfer_pay: 'Transfer',
  loyalty_settings: 'Loyalty settings',
  loyalty_type: 'Loyalty type',
  bonus_system: 'Bonus system',
  a_percentage_of_the_purchase_amount: 'A percentage of the purchase amount to be created to the points account of the customer',

  add_tax: 'Add tax',
  tax_rate: 'Tax rate, %',
  options: 'Options',

  add_predefined_ticket: 'Add predefined ticket',

  add_printer_group: 'Add printer group',
  count: 'Count',

  add_store: 'Add store',
  number_of_pos: 'Number of POS',
  description: 'Description',

  add_pos: 'Add pos',

  workgroup: 'Workgroup',
  add_workgroup: 'Add workgroup',
  create_employee: 'Create Employee',

  variant: 'Variant',
  sales_by_modifier: 'Sales by modifier',

  this_field_can_not_be_blank: 'This field can not be blank',
  wrong_phone: 'Wrong phone',

  update_customer: 'Update Customer',
  create_customer: 'Create Customer',

  rest_debt: 'Rest debt',
  paid: 'Paid',

  supplier_transaction: 'Supplier Transaction',
  balance: 'Balance',
  document: 'Document',
  uzs: 'UZS',
  usd: 'USD',
  all_suppliers: 'All Suppliers',
  coming: 'Coming',

  report_account: 'Report Account',
  all_cash: 'All Cash',
  all_card: 'All Card',
  consumption: 'Consumption',
  fees: 'Fees',
  one_time_fees: 'One time fees',
  salary: 'Salary',
  company_to_fees: 'Company to fees',
  create_fee: 'Create fee',
  add_fee: 'Add fee',
  comment: 'Comment',
  amount_type: 'Amount type',
  service: 'Service',
  balance_type: 'Balance type',
  currency: 'Currency',
  buttons: 'Buttons',
  add_button: 'Add button',
  pay_in: 'Pay in',
  pay_out: 'Pay out',
  none: 'None',
  create_task: 'Create task',
  add_limit: 'Add limit',
  qty: 'qty',
  kg: 'kg',
  to: 'To',
  from: 'From',
  bonus: 'Bonus',
  unit_name: 'Unit name',
  title: 'Title',
  task: 'Task',
  a: 'a',
  p: 'p',
  add_task: 'Add task',
  task_detail: 'Task detail',
  calculate_bonus_for_each: 'Calculate bonus for each',
  item_mark: 'Item mark',
  shop: 'Shop',
  restaurant: 'Restaurant',
  market: 'Market',
  pricing: 'Pricing',
  percent: 'Percent',
  update_prices: 'Update prices',
  all_items_from_the_supplier: 'All items from the supplier',
  low_stock_items_from_the_supplier: 'Low stock items from the supplier',
  create_and_receive: 'Create and receive',
  composite_items: 'Composite items',
  non_composite: "Non Composite",
  box: 'Box',
  litre: 'Litre',
  metre: 'Metre',
  active: 'Active',
  inactive: 'Inactive',
  all_statuses: 'All statuses',
  series: 'Series',
  count_by_type: 'Count by type',
  this_field_can_not_be_only_space: 'This field can not be only space',
  prices: 'Prices',
  multi_prices: 'Multi prices',
  percent1: 'Percent1',
  percent2: 'Percent2',
  percent3: 'Percent3',
  margin1: 'Margin1',
  price1: 'Price1',
  margin2: 'Margin2',
  price2: 'Price2',
  margin3: 'Margin3',
  price3: 'Price3',

  total_minutes: 'Total worked minutes',
  total_work_time: 'Total worked times',

  reminder: 'Reminder',
  hot_key: 'Hot Key',
  employees_can_use_inventory: 'Employees can use inventory',
  purchase_orders_cost: 'Purchase orders cost',
  stock_adjusment_cost: 'Stock adjusment cost',
  productions_cost: 'Productions cost',
  receipt_settings: 'Receipt settings',
  receipt: 'Receipt',
  header: 'Header',
  footer: 'Footer',
  show_customer_info: 'Show customer info',
  show_comments: 'Show comments',
  emailed_receipt: 'Emailed receipt',
  printed_receipt: 'Printed receipt',
  logo: 'Logo',
  items_for_scale: 'Items for scale',
  wrong_clock: 'Wrong clock',
  client: 'Client',
  all_types: 'All types',
  round: 'Round',
  upload_file: 'Upload file',
  items_file: 'Items file',
  by_receipt: 'By receipt',
  receipt_id: 'Receipt Id',
  use_sub_production: 'Use sub production',
  items_for_scale_txt: 'Items for scale txt',
  no_rounding: 'No rounding',
  rounding_to_50_summ: 'Rounding to 50 summ',
  rounding_to_500_summ: 'Rounding to 500 summ',
  both: 'Both',
  '1 qty': '1 qty',
  '2 qty': '2 qty',
  '3 qty': '3 qty',
  action: 'Action',
  apply: 'apply',
  margin_next: 'Margin next',
  price_next: 'Price next',

  couldnot_update_prices: 'Could not update prices',
  purchase_mark: 'Purchase mark',
  last_date_pricing: 'Last date pricing',
  create_purchase_mark: 'Create purchase mark',
  supplier_transaction_corrector: 'Supplier transaction corrector',
  get_back: 'Get back',
  item_price_change_history: 'Item price change history',
  old_price: 'Old price',
  new_price: 'New price',
  nds: 'NDS',
  a_percentage_of_the_nds: 'A percentage of the nds',
  nds_settings: 'NDS settings',
  can_sell: 'Can sell',
  auto_fill: 'Auto Fill',
  fill_sold: 'Fill sold',
  last_come: 'Last come',
  use_purchase_cost_on_pricing: 'Use purchase cost on pricing',
  sales_by_supplier: 'Sales by supplier',
  search: 'Search',
  no_item_found: 'No item found',
  create_items: 'Create items',
  add_new: 'Add new',
  please_enter_valid_barcode: 'Please enter valid barcode',
  item_allready_exist: 'Item allready exist',
  error_on_saving: 'Error on saving',
  creating_item: 'Creating items',
  updating_item: 'Updating items',
  confirm: 'Confirm',
  add_from_warehause: 'Add from warehause',
  add_items_from_warehause_quickly: 'Add items from warehause quickly',
  items_for_scale_second_txt: 'Items for scale second txt',
  pcs: 'Pcs',
  reminder_changed: 'Reminder changed',
  RLS1200: 'RLS1200',
  add_order: 'Add order',
  created_date: 'Created date',
  state: 'State',
  no_workgroup_orders: 'No workgroup orders',
  priority: 'Priority',
  urgent: 'Urgent',
  normal: 'Normal',
  low: 'Low',
  no_clients_found: 'No clients found',
  no_stores_found: 'No stores found',
  choose_at_least_one_item: 'Choose at least one item',
  reset_workgroups: 'Reset workgroups',
  workgroup_orders: 'Workgroup orders',
  info: 'Info',
  workgroups: 'Workgroups',
  used_quantity: 'Used quantity',
  doing: 'Doing',
  done: 'Done',
  rejected: 'Rejected',
  undo_rejecked: 'Undo rejecked',
  confirm_complete: 'Confirm complete',
  total_cost: 'Total cost',
  additional: 'Additional',
  total_amount: 'Total amount',
  total_actual_cost: 'Total actual cost',
  complete_confirmed: 'Complete confirmed',
  workgroup_order: 'Workgroup order',
  paid_debt: 'Paid debt',
  total_debt: 'Total debt',
  client_debt_by_category: 'Client debt by category',
  by_name: 'By name',
  past_debt: 'Past debt',
  order_information: 'Order information',
  device_information: 'Device information',
  add_device_information: 'Add device information',
  add_order_information: 'Add order information',
  back: 'Back',
  show_order_info: 'Show order info',
  show_device_info: 'Show device info',
  workgroup_items: 'Workgroup items',
  loading_info: 'Loading info',
  no_info_yet: 'No info yet',
  order_info: 'Order Info',
  device_info: 'Device Info',
  workgroup_comments: 'Workgroup comments',
  add_workgroup_comment: 'Add workgroup comment',
  production_item: 'Production item',
  total_production_cost: 'Total production cost',
  text: 'Text',
  show_shifts: 'Show shifts',
  additional_information: 'Additional information',
  add_additional_information: 'Add additional information',
  additional_info: 'Additional info',
  show_additional_info: 'Show additional info',
  workgroup_edit_cost: 'Workgroup edit cost',
  employees_can_use_workgroup: 'Employees can use workgroup',
  super_password: 'Super password',
  residue: 'Residue',
  device_name: 'Device name',
  start_time: 'Start time',
  finish_time: 'Finish time',
  save_as_draft: 'Save as draft',
  draft: 'Draft',
  edit_workgroup_order: 'Edit workgroup order',
  currency_type: 'Currency type',
  edit_current_receipt: 'Edit current receipt',
  customer_detail: 'Customer detail',
  pay_customer_debt: 'Pay customer debt',
  user_type: 'Choose user type',
  natural_user: 'Natural',
  legal_user: 'Legal',
  product_name: 'Product name',
  currency_value: 'Currency value',
  debt_history: 'Debt history',
  receipt_save_as_draft: 'Receipt save as draft',
  from_time: 'From time',
  to_time: 'To time',
  can_change_price: 'Can change price',
  warehause: 'Warehause',
  name_on_bot: 'Name on bot',
  show_on_bot: 'Show on bot',
  wharehouse_manager: 'Wharehouse manager',
  edit_sold_item: 'Edit sold item',
  all_categories: 'All categories',
  stock: 'Stock',
  fee: 'Fee',
  created_at: 'Created at',
  order_number: 'Order number',
  workgroup_orders_report: 'Workgroup orders report',
  total_actual_cost_sum: 'Total actual cost',
  total_production_cost_sum: 'Total production cost',
  can_access_to_shift: 'Can access to shift',
  total_spend: 'Total spend',
  total_receive: 'Total receive',
  total_favor: 'Total favor',
  add_receipt: 'Add receipt',
  create_receipt: 'Create receipt',
  option: 'Option',
  transfer: 'Transfer',
  reports_safe: 'Reports safe',
  by_user: 'By user',
  uzs_value: 'Uzs value',
  usd_value: 'Usd value',
  transfer_value: 'Transfer value',
  customer_debt: 'Customer debt',
  tech_map: 'Tech map',
  add_tech_map: 'Add tech map',
  tech_map_detail: 'Tech map detail',
  quality: 'Quality',
  tech_map_item: 'Tech map item',
  by_tech_map: 'By tech map',
  show_all: 'Show all',
  allready_exist: 'Allready exist',
  add_to_stock: 'Add to stock',
  transaction_documents: 'Transaction documents',
  create_document: 'Create document',
  report_by_items: 'Report by items',
  adjust: 'Adjust',
  credit: 'Credit',
  price_for_pieces: 'Price for pieces',
  workgroup_orders_report_by_employee: 'Workgroup report by employee',
  employee_name: 'Employee name',
  workgroup_name: 'Workgroup name',
  export_by_category: 'Export by category',
  enter_receipt_letter: 'Enter Receipt letter',
  receipt_letter: 'Receipt letter',
  refund_receipt: 'Refund receipt',
  service_name: 'Service name',
  client_name: 'Client name',
  reset_count: 'Reset count',
  reminder_refund: 'Reminder refund',
  returned_reminder: 'Returned reminder',
  last_priced_goods: 'Last priced goods',
  item_for_mettletoledo: 'Mettler toledo SPCT2',
  item_for_cas_turkish: 'Cas Turkish ',
  show_on_bot_services: 'Show on bot services',
  image: 'Image',
  color: 'Color',
  delivery: 'Delivery',
  discount: 'Discount',
  dimentions: 'Dimentions',
  brand: 'Brand',
  set_client: 'Set client',
  items_for_scale_cas: 'Items for scale CAS',
  ok: 'Ok',
  item_for_mettletoledo_spct1: 'Mettler toledo SPCT1',
  telegram_acces: 'Telegram acces',
  store_items: 'Store items',
  non_store: 'Non store',
  organization: 'Organization',
  organizations: 'Organizations',
  add_organization: 'Add organization',
  organization_name: 'Organization name',
  loyalty_bonus: 'Loyalty bonus',
  inn: 'INN',
  epos_token: 'Epos token',
  payments: 'Payments',
  mxik: 'ID №',
  mxik_search: 'Mxik search',
  group_name_uz: 'Group name',
  class_name_uz: 'Class name',
  position_uz: 'Position',
  sub_position_uz: 'Sub position',
  attribute_uz: 'Attribute',
  unit: 'Unit',
  unit_of_pack: 'Unit of pack',
  nds_value: 'NDS value',
  cash_backs: 'Cashback',
  employees_can_use_reports: 'Employees can use reports',
  report: 'Report',
  sale_summary: "Sale summary",
  accaunt: 'Accaunt',
  abs: 'ABS',
  sale_by_item: 'Sale by item',
  sale_by_category: 'Sale by category',
  sale_by_supplier: 'Sale by supplier',
  sale_by_payment: 'Sale by payment',
  shift: 'Shift',
  employees_can_use_items: 'Employees can use items',
  list: 'List',
  print_label: 'Print label',
  price_change_history: 'Price change history',
  employees_can_use_settings: 'Employees can use settings',
  time_cards: 'Time cards',
  can_use_employees: 'Can use employees',
  total_worked: 'Total hours worked',
  employees_can_use_customers: 'Employees can use customers',
  create_taxes: 'Create taxes',
  create_store: 'Create store',
  create_pos_device: 'Create pos device',
  create_access: 'Create access',
  create_time_card: 'Create time card',
  create_stock_adjustmen: 'Create stock adjustmen',
  create_inv_count: 'Create inv count',
  create_supplier_create_doc: 'Create supplier create doc',
  create_good_sale: 'Create item',
  create_good_category: 'Create good category',
  create_modifier: 'Create modifier',
  create_discount: 'Create discount',
  create_reciept: 'Create reciept',
  employees_can_use_create: 'Employees can use create',
  potential: "Potential",
  retail: "Retail",
  item_edit: "Item edit",
  error_404_sorry: "Sorry, you do not have permission to access this page!",
  export_item_excel: 'Export item excel',
  partition_item: 'Partition item',
  partition_valuation: 'Partition valuation',
  good_name: 'Good name',
  quantity_left: 'Quantity left',
  p_order: 'P order',
  all_amount: 'All amount',
  item_mark_edit: 'Item mark edit',
  beta: 'BETA',
  add_mark: 'Add Mark',
  zero: 'Zero',
  not_zero: 'Not zero',
  purchase_employee: 'Internal orders',
  add_purchase_employee: 'Add purchase employee',
  real_stock: 'Realstock',
  accept_by: 'Accepted by',
  accept: 'Accepted',
  reciepts_count: 'Reciepts count',
  average_reciept: 'Average reciept',
  user_id: 'User id',
  director_name: 'Director name',
  accaunter: 'Accaunter',
  taxes_pair_code: 'Taxes pair code',
  org_phone_number: 'Organization phone number',
  promotions_and_discounts: "Promotions and discounts",
  discount_create: "Discount create",
  add_dicount: 'Add dicount',
  start_date: 'Start date',
  end_date: 'End date',
  discount_update: 'Discount update',
  import_items_excel: 'Import items excel',
  download: "Download",
  inventory_history_report: "Inventory history report",
  is_same_service_price: "Is same service price",
  marking: "Marking",
  is_refund: "Is refund",
  client_status: 'Client status',
  add_status: 'Add status',
  club_card: 'Club card',
  new_item_create: 'New item create',
  material_report: 'Material report',
  partiation_no: 'Partiation no',
  qty_box: 'QTY box',
  sale_report: 'Sale report',
  partition: 'Partition №',
  import_by_barcode: 'Import by barcode',
  cashback_out: 'Cashback out',
  birthday: 'Birthday',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  packages: 'Packages',
  working_days: 'Working days',
  checkedProductsCount: 'Checked products count',
  syncProductsCount: 'Synced products count',
  syncNotStarted: 'Sync not started. Click sync to start',
  sync: 'sync',
  startedAt: 'Stared at',
  endedAt: 'Finished at',

}
